import styles from "./goBack.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
export const GoBackButton = ({ onClickHandler, game, customClass }) => {
      return (
            <button
                  onClick={(event) => {
                        game.sounds.clickSound.play();

                        onClickHandler(event);
                  }}
                  className={styles["go-back-button"] + " " + customClass}
                  tabIndex="-1"
            >
                  <FontAwesomeIcon icon={faArrowLeft} />
            </button>
      );
};
